import { GalleryItem, GalleryItemMenu, GalleryItemProperty } from "@/features/common/components/dataview/GalleryItem";
import { usePriceAlertUpdate } from "@/features/priceAlerts/api/usePriceAlertUpdate";
import { PriceAlertMetricLabels } from "@/features/priceAlerts/PriceAlertMetric";
import { PriceAlertsMenu, PriceAlertsMetricDisplay, PriceAlertsStatusBadge, toggleEnabledPriceAlert, type PriceAlertsDataViewProps } from "@/features/priceAlerts/components/PriceAlertRowDisplays";
import { PriceAlertTargetLabels } from "@/features/priceAlerts/PriceAlertTarget";
import { collectionArts } from "@/lib/media/collectionArts";
import type { FC } from "react";

export const PagePriceAlertsDataViewGalleryItem: FC<PriceAlertsDataViewProps> = priceAlert => {
	const {
		targetType,
		targetName,
		targetDescription,
		metricType,
		onDeletePriceAlert,
		onEditPriceAlert,
		onViewPriceAlert
	} = priceAlert;

	const updatePriceAlert = usePriceAlertUpdate();

	const isVariant = priceAlert.targetType === "Variant";
	const imageUrl = priceAlert.targetType === "Variant" ? priceAlert.targetImageUrl : collectionArts[priceAlert.targetImage];

	return (
		<GalleryItem
			title={targetName}
			description={targetDescription}
			imageUrl={imageUrl}
			isProductImage={isVariant}
			isLoading={updatePriceAlert.isPending}
			error={updatePriceAlert.error}
			onClick={() => onEditPriceAlert(priceAlert)}>
			<GalleryItemMenu>
				<PriceAlertsMenu priceAlert={priceAlert} onEnabledPriceAlert={() => toggleEnabledPriceAlert(priceAlert, updatePriceAlert)} onViewPriceAlert={onViewPriceAlert} onDeletePriceAlert={onDeletePriceAlert} />
			</GalleryItemMenu>
			<GalleryItemProperty label="Type">
				{PriceAlertMetricLabels[metricType]}
			</GalleryItemProperty>
			<GalleryItemProperty label="Applies To">
				{PriceAlertTargetLabels[targetType]}
			</GalleryItemProperty>
			<GalleryItemProperty label="Metric">
				<PriceAlertsMetricDisplay {...priceAlert} />
			</GalleryItemProperty>
			<GalleryItemProperty label="Status">
				<PriceAlertsStatusBadge {...priceAlert} />
			</GalleryItemProperty>
		</GalleryItem>
	);
};
